import { useSelector } from 'react-redux';
import ProviderCommonApi from '../../../../API/provider/common-api';
import StocksApi from '../../../../API/provider/stocks-api';
import { TYPE_BUTTONS } from '../../../../constans';
import WhiteBlock from '../../../Basic/Blocks/WhiteBlock';
import Button from '../../../Basic/Buttons/Button';
import SendButton from '../../../Basic/Buttons/Send';
import Column from '../../../Basic/Blocks/Column';
import Row from '../../../Basic/Blocks/Row';

const ProviderDasboardContentWhiteBlock = ({ providerId, isSmallProvider = false, isLoadImage = false }) => {
  const user = useSelector((store) => store.user);

  const isAdmin = user.role === 'owner' || user.role === 'admin';

  console.log(providerId)
  return (
    <WhiteBlock title="Контент" style={{ minWidth: '500px', selfAlign: 'normal', marginLeft: '20px' }}>
      <Column>
        {isAdmin && (
          <Row>
            {isSmallProvider && (
              <SendButton
                multiple={true}
                sendApi={StocksApi.saveParser}
                sendData={{ data: { providerId } }}
                style={{ marginRight: '15px' }}
                width={'230px'}
              >
                Подгрузить парсер файл
              </SendButton>
            )}
            {isLoadImage && (
              <Button type={TYPE_BUTTONS.BLUE} onClick={() => ProviderCommonApi.loadImages({ data: { providerId } })}>
                Выгрузить изображения
              </Button>
            )}
          </Row>
        )}

        <Row style={{ marginTop: '10px' }}>
          <SendButton
            // multiple={true}
            sendApi={ProviderCommonApi.saveDefault}
            style={{ marginRight: '5px' }}
          >
            Подгрузить основные данные
          </SendButton>

          <SendButton
            // multiple={true}
            sendApi={ProviderCommonApi.saveContent}
          >
            Подгрузить контент данные
          </SendButton>

          <SendButton
            // multiple={true}
            sendApi={ProviderCommonApi.saveWbData}
          >
            Подгрузить вб данные
          </SendButton>
        </Row>
      </Column>
    </WhiteBlock>
  );
};

export default ProviderDasboardContentWhiteBlock;
